import './Scheduled.sass';

import React, { FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ScheduledProps } from './Scheduled.interface';
import { Button, Header, Placeholder, ScrollView } from '$uikit';
import { Loader, Post } from '$shared/components';
import { postsActions, postsSelector } from '$store/posts';
import { useTranslator } from '$hooks';

export const Scheduled: FC<ScheduledProps> = ({ ownerId }) => {
  const dispatch = useDispatch();
  const { isScheduledLoading, isScheduledFailed, scheduled } = useSelector(postsSelector);
  const t = useTranslator();

  useEffect(() => {
    dispatch(postsActions.loadScheduled({ ownerId }));
  }, [ownerId]);

  const handleRetry = useCallback(() => {
    dispatch(postsActions.loadScheduled({ ownerId }));
  }, []);

  function renderContent() {
    if (isScheduledLoading) {
      return <Loader isWrapped />;
    }

    if (isScheduledFailed) {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={
            <Button size="small" onClick={handleRetry}>
              {t('failed_button')}
            </Button>
          }
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    if (!scheduled.length) {
      return <Placeholder>{t('scheduled_empty')}</Placeholder>;
    }

    return scheduled.map((postId) => <Post key={postId} postId={postId} />);
  }

  return (
    <>
      <Header showCloseButton>{t('scheduled_title')}</Header>
      <ScrollView>{renderContent()}</ScrollView>
    </>
  );
};
